import { render, staticRenderFns } from "./SyncTreatments.vue?vue&type=template&id=3de8efab&scoped=true&"
import script from "./SyncTreatments.vue?vue&type=script&lang=js&"
export * from "./SyncTreatments.vue?vue&type=script&lang=js&"
import style0 from "./SyncTreatments.vue?vue&type=style&index=0&id=3de8efab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8efab",
  null
  
)

export default component.exports